import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { Component } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { eventDataPropType } from '../../../reporting/components/resources/common/propTypes';
import renderSummary from '../resources/util/renderEventSummary';
export var RCEEvent = /*#__PURE__*/function (_Component) {
  function RCEEvent() {
    _classCallCheck(this, RCEEvent);
    return _callSuper(this, RCEEvent, arguments);
  }
  _inherits(RCEEvent, _Component);
  return _createClass(RCEEvent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        event = _this$props.event,
        currentEventData = _this$props.currentEventData;
      var message = event.getIn(['eventData', 'message']);
      return renderSummary(message, currentEventData.multipleSessionAttempt);
    }
  }]);
}(Component);
_defineProperty(RCEEvent, "propTypes", {
  event: ImmutablePropTypes.record.isRequired,
  currentEventData: eventDataPropType
});
export default RCEEvent;